import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrSeparator from 'client/components/SrSeparator';
import SetupHealthChecks from 'client/components/SetupHealthChecks/SetupHealthChecks';
import SrSetupHealthGoLiveSection from 'client/components/SrSetupHealthGoLiveSection/SrSetupHealthGoLiveSection';

const SrSetupHealth = ({
  setupHealth,
  listingId,
  requirePhotos,
  photographyArrivedDate,
  photoLiveDate,
  photoLiveCompletedDate,
  firstInReviewDate,
  firstActiveDate,
}) => {
  return (
    <SrBox>
      <SetupHealthChecks
        setupHealth={setupHealth}
        listingId={listingId}
      />
      <SrSeparator
        marginTop='17px'
        marginBottom='17px'
      />
      <SrSetupHealthGoLiveSection
        photographyRequired={requirePhotos}
        photographyArrivedDate={photographyArrivedDate}
        photographyLiveDate={photoLiveDate}
        photographyLiveCompletedDate={photoLiveCompletedDate}
        listingFirstInReviewDate={firstInReviewDate}
        listingFirstActiveDate={firstActiveDate}
      />
    </SrBox>
  );
};

SrSetupHealth.propTypes = {
  setupHealth: PropTypes.object.isRequired,
  listingId: PropTypes.number.isRequired,
  requirePhotos: PropTypes.bool.isRequired,
  photographyArrivedDate: PropTypes.string,
  photoLiveDate: PropTypes.string,
  photoLiveCompletedDate: PropTypes.string,
  firstInReviewDate: PropTypes.string,
  firstActiveDate: PropTypes.string,
};

export default SrSetupHealth;
